// Resto del sitio: builder en runtime, home, horario, cookies, páginas de error — English (US). Mismas claves que es/site.ts.
export const siteEn = {
  embeds: {
    howItWorks: 'How does it work?',
    benefitsTitle: 'Benefits',
    contactInfo: 'Contact information',
    phone: 'Phone',
    email: 'Email',
    emails: 'Emails',
    openingHours: 'Business hours',
    teamTitle: 'Our Team',
    agendar: {
      step1Title: 'Choose the location',
      step1Desc: 'Select where you want to visit us.',
      step2Title: 'Pick a day and time',
      step2Desc: 'Check availability and book your time.',
      step3Title: 'Leave us your details',
      step3Desc: 'Enter your name and contact information.',
      step4Title: "We'll be expecting you",
      step4Desc: "You'll receive a confirmation of your visit.",
    },
  },
  whatsapp: {
    contactAria: 'Contact us on WhatsApp',
  },
  // /about sin página del builder (TraditionalAbout). `knowMore` lleva el
  // espacio final: el nombre va en un nodo aparte, como siempre.
  about: {
    title: 'About Us',
    knowMore: 'Learn more about ',
    fallbackName: 'us',
    comingSoon: 'This page will be available soon.',
  },
  error: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred while loading this section. Please try again.',
    retry: 'Try again',
  },
  cookies: {
    aria: 'Cookie consent',
    title: 'We use cookies to improve your experience',
    description: 'We use third-party cookies (Meta, Google) to measure traffic and show you more relevant content. You can accept or reject their use at any time.',
    reject: 'Reject',
    accept: 'Accept',
  },
  nav: {
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
    menuClose: 'Close menu',
    menuOpen: 'Open menu',
    toggleTheme: 'Toggle theme',
  },
  footer: {
    rights: 'All rights reserved.',
  },
  vehicles: {
    searchPlaceholder: 'Search by make, model or year...',
    searchBrand: 'Search make...',
    searchYear: 'Search year...',
    searchType: 'Search type...',
    noOptions: 'No options available',
    filters: 'Filters',
    reset: 'Reset',
    back: 'Back',
    clear: 'Clear',
    hideFilters: 'Hide filters',
    showFilters: 'Show filters',
    priceRange: 'Price Range',
    brand: 'Make',
    dealership: 'Location',
    year: 'Year',
    vehicleType: 'Vehicle Type',
    fuel: 'Fuel type',
    condition: 'Condition',
    color: 'Color',
    carType: 'Body type',
    transmission: 'Transmission',
    priceFromTo: 'Price From - To',
    yearFromTo: 'Year From - To',
    allMasc: 'All',
    allFem: 'All',
    exploreStock: 'Explore our inventory',
    priceOnRequest: 'Call for price',
    viewDetails: 'View details',
    available: 'Available',
    kmsUnit: 'km',
    vehicleAlt: 'Vehicle',
    noneAvailableTitle: 'No vehicles available',
    noneAvailableText: 'There are no vehicles to show right now',
    noResultsTitle: 'No vehicles found',
    noResultsText: 'Try adjusting the filters',
    noResultsTextSearch: 'Try adjusting the filters or searching for something else',
    removeAllFilters: 'Remove all filters',
    found: 'vehicles found',
    noMatches: 'There are no vehicles that match the selected filters.',
    sortBy: 'Sort by',
    sortDateDesc: 'Newest first',
    sortDateAsc: 'Oldest first',
    sortPriceAsc: 'Price: Low to High',
    sortPriceDesc: 'Price: High to Low',
    sortYearDesc: 'Year: Newest',
    sortYearAsc: 'Year: Oldest',
    sortMileageAsc: 'Mileage: Low to High',
    scrollLeft: 'Scroll left',
    scrollRight: 'Scroll right',
    types: {
      all: 'All',
      suv: 'SUVs',
      sedan: 'Sedans',
      hatchback: 'Hatchbacks',
      pickup: 'Pickups',
      camioneta: 'Trucks',
      van: 'Vans',
      coupe: 'Coupes',
      wagon: 'Wagons',
      trabajo: 'Work vehicles',
    },
  },
  hero: {
    badge: 'Your next car is waiting for you',
    makeModel: 'Make and Model',
    makeModelPlaceholder: 'e.g. Toyota Corolla',
    from: 'From',
    to: 'To',
    price: 'Price',
    min: 'Minimum',
    max: 'Maximum',
    model: 'Model',
    search: 'Search',
    featuredCarAlt: 'Featured car',
    allBrands: 'All makes',
    allModels: 'All models',
    allYears: 'All years',
    anyPrice: 'Any price',
    trustedDealer: 'Your trusted dealership',
    warrantyIncluded: 'Warranty included',
    flexibleFinancing: 'Flexible financing',
    homeDelivery: 'Home delivery',
  },
  sections: {
    learnMore: 'Learn more',
    meetUs: 'Meet us',
    videoInvalid: 'Please enter a valid video URL (YouTube or Vimeo).',
    videoExample: 'e.g. https://www.youtube.com/watch?v=VIDEO_ID',
  },
  carousel: {
    empty: 'Add images to the carousel from the panel on the right',
    image: 'Image',
    previous: 'Previous',
    next: 'Next',
    goTo: 'Go to image',
  },
  stats: {
    eyebrow: 'By the numbers',
    title: 'Our numbers',
  },
  whyUs: {
    item1Title: 'Warranty',
    item1Description: 'All our vehicles come with a warranty',
    item2Title: 'Financing',
    item2Description: 'Flexible financing options',
    item3Title: 'Quality',
    item3Description: 'Carefully selected and inspected vehicles',
  },
  skeleton: {
    all: 'All',
    sedan: 'Sedan',
  },
  // Textos DE FÁBRICA de las secciones del builder. No se leen con t(): hoy los
  // usa builder2/utils/defaultsPt (solo es ↔ pt). Acá están por paridad de claves.
  builderDefaults: {
    d002: 'Section title',
    d003: 'A title to go with the image',
    d004: "Tell us here what you'd like to highlight. This block combines an image with text and an optional button.",
    d005: 'Card title',
    d006: 'A short description of what this card offers.',
    d019: 'A standout benefit',
    d020: "Explain in one line why it's a great fit for the customer.",
    d106: 'Toyota Corolla buyer',
    d108: 'Honda CR-V buyer',
    d110: 'Nissan Sentra buyer',
    d199: "If you're not satisfied, we'll give you your money back",
  },
};
